import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Star, ExternalLink, Navigation, Store } from 'lucide-react';
interface Retailer {
  id: number;
  name: string;
  address: string;
  city: string;
  rating: number;
  reviews: number;
}
const retailers: Retailer[] = [{
  id: 1,
  name: "Badri's Tropical",
  address: 'Noordeinde 166',
  city: '1334 BC Almere',
  rating: 4.0,
  reviews: 141
}, {
  id: 2,
  name: 'Tropical Center Lelystad',
  address: 'Agorahof 22',
  city: '8232 DX Lelystad',
  rating: 4.3,
  reviews: 64
}, {
  id: 3,
  name: 'Toko Combe',
  address: 'Noordeinde 83-85',
  city: '1334 AM Almere',
  rating: 4.3,
  reviews: 162
}, {
  id: 4,
  name: 'Supertoko',
  address: 'Renswoudestraat 50',
  city: '1106 BK Amsterdam',
  rating: 3.7,
  reviews: 55
}, {
  id: 5,
  name: 'Toko Almere Poort',
  address: 'Europalaan 907',
  city: '1363 BM Almere',
  rating: 4.1,
  reviews: 138
}, {
  id: 6,
  name: 'Toko Amardjoti',
  address: 'Binnenhof 52',
  city: '1354 KE Almere',
  rating: 4.5,
  reviews: 75
}];
export function Retailers() {
  return <section id="retailers" className="py-24 bg-white" data-id="element-187">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-188">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 mb-16" data-id="element-189">
          <div className="max-w-2xl" data-id="element-190">
            <span className="text-brand-orange font-medium tracking-widest uppercase text-sm" data-id="element-191">
              Verkooppunten
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-dark mt-4 mb-6" data-id="element-192">
              Vind Capsin Bij Jou <br data-id="element-193" />
              In De Buurt
            </h2>
            <p className="text-brand-gray text-lg" data-id="element-194">
              Als particulier kun je onze heerlijke peperproducten kopen op
              onderstaande verkooppunten. Steeds meer toko's en speciaalzaken
              door heel Nederland!
            </p>
          </div>

          {/* Ondernemer CTA */}
          <div className="w-full lg:w-auto bg-brand-cream rounded-2xl p-6 flex items-center gap-4 border border-brand-orange/10" data-id="element-195">
            <div className="w-12 h-12 rounded-full bg-brand-red/10 flex items-center justify-center flex-shrink-0" data-id="element-196">
              <Store className="w-6 h-6 text-brand-red" data-id="element-197" />
            </div>
            <div data-id="element-198">
              <p className="font-serif font-bold text-brand-dark" data-id="element-199">
                Bent u een ondernemer?
              </p>
              <Link to="/contact" className="text-sm text-brand-red font-medium hover:underline inline-flex items-center gap-1" data-id="element-200">
                Neem contact op voor de groothandel
                <ExternalLink size={13} data-id="element-201" />
              </Link>
            </div>
          </div>
        </div>

        {/* Retailer grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-202">
          {retailers.map(retailer => <div key={retailer.id} className="group bg-brand-cream rounded-2xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-203">
              <div className="flex items-start justify-between gap-4 mb-4" data-id="element-204">
                <div className="flex items-start gap-3" data-id="element-205">
                  <div className="w-10 h-10 rounded-full bg-brand-red flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform" data-id="element-206">
                    <MapPin className="w-5 h-5 text-white" data-id="element-207" />
                  </div>
                  <div data-id="element-208">
                    <h3 className="font-serif font-bold text-lg text-brand-dark leading-tight" data-id="element-209">
                      {retailer.name}
                    </h3>
                    <p className="text-sm text-brand-gray mt-1" data-id="element-210">
                      {retailer.address}
                      <br data-id="element-211" />
                      {retailer.city}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-1.5 mb-6" data-id="element-212">
                <Star size={15} className="fill-brand-yellow text-brand-yellow" data-id="element-213" />
                <span className="text-sm font-bold text-brand-dark" data-id="element-214">
                  {retailer.rating.toFixed(1)}
                </span>
                <span className="text-sm text-brand-gray" data-id="element-215">
                  ({retailer.reviews} reviews)
                </span>
              </div>

              <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${retailer.name} ${retailer.address} ${retailer.city}`)}`} target="_blank" rel="noopener noreferrer" className="mt-auto flex items-center justify-center gap-2 bg-white text-brand-dark py-3 rounded-xl text-sm font-medium hover:bg-brand-red hover:text-white transition-colors" data-id="element-216">
                <Navigation size={16} data-id="element-217" />
                Route plannen
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}